export default function minMaxFiltersColumn() {
	return [{
		name: "numMin", label: "Shared Minimum?",
		options: {
			display: 'excluded',
			filterType: 'checkbox',
			customBodyRowRender: value => value > 1 ? 'Yes' : 'No'
		}
	}, {
		name: "numMax", label: "Shared Maximum?",
		options: {
			display: 'excluded',
			filterType: 'checkbox',
			customBodyRowRender: value => value > 1 ? 'Yes' : 'No'
		}
	}]
}